import { IAdvertiserGridRow } from '@/Interfaces/Advertiser.interface';
import StatusChip from '@/components/StatusChip';
import { getActiveInactiveStatusProps } from '@/components/StatusChip/StatusProps';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const StatusCell = ({ value }: GridRenderCellParams<IAdvertiserGridRow>) => {
  return (
    <div className='overflow-hidden'>
      <StatusChip {...getActiveInactiveStatusProps(value)} />
    </div>
  );
};

export default StatusCell;
